export default __webpack_public_path__ + "static/media/universal-blockchain-video.7c240ad7.mp4";